export default __webpack_public_path__ + "static/media/9_Ocean Waves - 30s sample.0bb264cd.mp3";